import type { RequestContext } from "../context/request-context.js";
import { AppError, ErrorCode } from "../../shared/errors/app-error.js";
import type { IntegrityReportId, ProfessionalId } from "../../shared/kernel/identifiers.js";
import type { IntegrityReport } from "../../domain/report/integrity-report-domain.js";
import { AuditAction } from "../../audit/audit-log.js";
import type { AuditRecorder } from "../../audit/audit-recorder.js";

export class SignatureService {
  constructor(private audit?: AuditRecorder) {}

  async sendSignatureRequestEmail(
    context: RequestContext,
    reportId: IntegrityReportId,
    professionalId: string, // PLH professional
    userEmail: string // Email to send the request to
  ): Promise<void> {
    console.log(`[Mock Email Sender] Enviando solicitação de assinatura digital...`);
    console.log(`- Para: ${userEmail}`);
    console.log(`- Relatório ID: ${reportId}`);
    console.log(`- PLH Responsável: ${professionalId}`);
    
    // In a real application, this would call an external API like DocuSign or an internal SMTP server.
    
    await this.audit?.record(context, {
      action: 'SendSignatureEmail' as AuditAction,
      entityType: 'IntegrityReport',
      entityId: reportId,
      previousState: null,
      newState: { awaitingSignatureFor: professionalId } as any,
      metadata: { sentTo: userEmail }
    });
  }
}
